module.exports = __webpack_public_path__ + "../assets/img/ApploiRegular.948ad41750504e23a8a523b9fadd3e07.png";